import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DependentsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { DependentsReportApi } from '../api/dependent-report-api';
import { DependentReport, ReviewsReport } from '../model';
import { Repository } from './repository';
import { ReviewsReportFilterForm } from '../../../shared/interfaces/shared-interfaces';
import { ReviewsReportApi } from '../api/review-reports-api';

@Injectable({
  providedIn: 'root',
})
export class ReviewsReportRepository extends Repository {
  constructor(private reviewsReportApi: ReviewsReportApi) {
    super();
  }

  getReviewsReport(filter: ReviewsReportFilterForm): Observable<DataWithPagination<ReviewsReport[]>> {
    return this.reviewsReportApi.getReviewsReport(filter);
  }

  adminApproveReview(reviewId: string): Observable<string> {
    return this.reviewsReportApi.adminApproveReview(reviewId);
  }

  adminHideApproveReview(reviewId: string): Observable<string> {
    return this.reviewsReportApi.adminHideApproveReview(reviewId);
  }
}
